import Vue from 'vue/dist/vue.esm';

// Webpack 4 no longer seems to allow shared state
if (typeof window.eventBus === 'undefined') {
  window.eventBus = new Vue();
}

export const EventBus = window.eventBus
